import React from 'react';
import AsyncComponent from './async';
import {Route} from 'react-router-dom';

export default [
  <Route
    key="/business/campaign/virtual-makeup"
    path="business/campaign/virtual-makeup"
    element={<AsyncComponent />}
  />,
];
